module.exports = __webpack_public_path__ + "img/icon-cloud.033f03f3.svg";